
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-[50vh] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('https://public.readdy.ai/ai/img_res/279f71f6ca2e8bce0ba2f691e0347551.jpg')`
        }}
      >
        <div className="max-w-6xl mx-auto px-4 text-center text-white">
          <h1 className="text-5xl font-bold mb-8">편안한 물류친구가 되겠습니다.</h1>
          <p className="text-2xl mb-12 leading-relaxed font-semibold">
            국내와 글로벌 이커머스 물류에 특화된 독보적 3PL 서비스
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white/15 backdrop-blur-sm rounded-xl p-6">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">내륙 중심의 최적 입지</h3>
            </div>
            
            <div className="bg-white/15 backdrop-blur-sm rounded-xl p-6">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">고도로 숙련된 인력</h3>
            </div>
            
            <div className="bg-white/15 backdrop-blur-sm rounded-xl p-6">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">글로벌 이커머스</h3>
            </div>
          </div>
          
          <p className="text-xl font-semibold">
            의류 / 패션 / 반려용품 / 잡화 등 모든 품목 기반 글로벌 이커머스까지
          </p>
        </div>
      </section>

      {/* Service Differentiation */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="space-y-4">
              <p className="text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-medium">
                재고관리, 포장, 발송등 평범한 물류서비스는 누구나 하는 것입니다
              </p>
              <p className="text-4xl text-blue-600 max-w-4xl mx-auto leading-relaxed font-bold">
                올딩스 로지스의 물류서비스는 다릅니다
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-arrow-go-back-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">국내 최고의 반품관리 서비스</h3>
              <p className="text-gray-600">
                체계적인 반품 처리 시스템으로 고객 만족도를 높이고 재판매 가능한 상품의 손실을 최소화합니다.
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-search-eye-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">패션잡화 / 반려용품 검품실 운영</h3>
              <p className="text-gray-600">
                전문 검품실에서 패션 및 잡화 상품의 품질을 철저히 검사하여 완벽한 상품만 고객에게 전달합니다.
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-amazon-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">아마존 입고 서비스</h3>
              <p className="text-gray-600">
                아마존 FBA 입고 요구사항에 맞춘 전문 서비스로 글로벌 진출을 완벽하게 지원합니다.
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shopping-bag-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">큐텐 물류 서비스</h3>
              <p className="text-gray-600">
                큐텐 플랫폼 특화 물류 서비스로 일본 시장 진출을 효과적으로 지원합니다.
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-checkbox-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">오피킹 제로</h3>
              <p className="text-gray-600">
                완벽한 자동화 시스템으로 피킹 오류를 제로화하여 고객 신뢰도를 극대화합니다.
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">물류비 최소화</h3>
              <p className="text-gray-600">
                최적화된 프로세스와 효율적인 운영으로 물류비용을 최소화하여 고객의 수익성을 향상시킵니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              전문 서비스 영역
            </h2>
            <p className="text-xl text-gray-600">
              의류 / 패션 / 잡화 등 모든 품목 기반 글로벌 이커머스까지
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shirt-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">의류 &amp; 패션</h3>
              <p className="text-gray-600 mb-4">
                패션 업계의 특성을 이해한 전문적인 물류 서비스를 제공합니다. 
                시즌별 재고 관리부터 빠른 회전율이 요구되는 패션 아이템까지 완벽하게 처리합니다.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li>• 의류 전용 보관 시설</li>
                <li>• 사이즈별 분류 시스템</li>
                <li>• 시즌 재고 관리</li>
                <li>• 패션 브랜드 맞춤 포장</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-gift-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">반려용품 &amp; 생활용품</h3>
              <p className="text-gray-600 mb-4">
                다양한 형태와 크기의 반려용품 및 생활용품을 안전하고 효율적으로 관리합니다. 
                세심한 포장과 배송으로 고객 만족도를 높입니다.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li>• 다양한 크기 대응 가능</li>
                <li>• 파손 방지 전문 포장</li>
                <li>• 카테고리별 분류 관리</li>
                <li>• 특수 보관 조건 대응</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-global-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">글로벌 이커머스</h3>
              <p className="text-gray-600 mb-4">
                해외 진출을 꿈꾸는 이커머스 업체를 위한 국제 물류 서비스를 제공합니다. 
                복잡한 통관 절차부터 현지 배송까지 원스톱으로 해결합니다.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li>• 국제 배송 네트워크</li>
                <li>• 통관 대행 서비스</li>
                <li>• 현지 파트너십</li>
                <li>• 다국가 동시 배송</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shopping-cart-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">이커머스 풀필먼트</h3>
              <p className="text-gray-600 mb-4">
                온라인 쇼핑몰 운영에 필요한 모든 물류 업무를 대행합니다. 
                주문 접수부터 배송 완료까지 전 과정을 자동화된 시스템으로 관리합니다.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li>• 실시간 재고 관리</li>
                <li>• 자동 주문 처리</li>
                <li>• 당일 출고 서비스</li>
                <li>• 반품/교환 처리</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Company Values */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              핵심 가치
            </h2>
            <p className="text-xl text-gray-600">
              올딩스 로지스가 추구하는 가치와 원칙
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">고객 중심</h3>
              <p className="text-gray-600">
                고객의 성공이 우리의 성공입니다. 
                고객의 니즈를 정확히 파악하고 
                최적의 솔루션을 제공합니다.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">신뢰성</h3>
              <p className="text-gray-600">
                약속한 시간에 안전하게 배송하는 것이 
                우리의 기본입니다. 신뢰할 수 있는 
                파트너가 되겠습니다.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">혁신</h3>
              <p className="text-gray-600">
                끊임없는 기술 혁신과 프로세스 개선을 통해 
                더 나은 서비스를 제공하기 위해 
                노력합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
